import unhappy from "../../Images/unhappy.png"
import neutral from "../../Images/neutral.png"
import happy from "../../Images/happy.png"
import { HitechSettings } from "../../Common/CommonVariables";

const currentBaseUrl = window.location.origin;

const NPSQuestionnaireFirstStep = ({ handleFirstStepClick }) => {
    return (
        <>
            <div className="content-wrapper">
                <div className="middle-content-wrapper">
                    <div className="text-content">
                        <p>Dear User,</p>

                        <p>Thank you for your Patronage!</p>

                        <p>At {currentBaseUrl ===  HitechSettings.baseUrl
                                        ? "Hitech" : "Metropolis"} , we strive to deliver quality services to our clients. Your continuous support and feedback always helps us to improvise our processes and services.</p>

                        <p>Do take 5 minutes of your time to complete this quick survey and let us know what you feel about us.</p>
                    </div>

                    <div className="emoji-wrapper">
                        <div>
                            <p>Based on your relationship with {currentBaseUrl ===  HitechSettings.baseUrl
                                        ? "Hitech" : "Metropolis"}, how likely are you to recommend us as your preferred Lab to your customers and acquaintances?</p>
                        </div>

                        <div className="emoji-button-wrapper">
                            <div>
                                <button type="button" className="emoji-button" onClick={() => handleFirstStepClick("Un happy")}>
                                    <img src={unhappy} alt="Unhappy Image" className="emoji-img" />
                                </button>
                                <p>Unhappy</p>
                                <p>0-6</p>
                            </div>
                            <div>
                                <button type="button" className="emoji-button" onClick={() => handleFirstStepClick("Neutral")}>
                                    <img src={neutral} alt="Neutral Image" className="emoji-img" />
                                </button>
                                <p>Neutral</p>
                                <p>7&8</p>
                            </div>
                            <div>
                                <button type="button" className="emoji-button" onClick={() => handleFirstStepClick("Happy")}>
                                    <img src={happy} alt="Happy Image" className="emoji-img" />
                                </button>
                                <p>Happy</p>
                                <p>9&10</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer">
                    <p>Best regards,</p>
                    <p>Quality Assurance Team.</p>
                </div>
            </div>
        </>
    )
}

export default NPSQuestionnaireFirstStep